import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import OtpInput from "react-otp-input";
import otpicon from "../otp-icn.svg";

const EnterOTP = ({ handleAuthentication }) => {
  const [otp, setOtp] = useState("");
  const [loading, setloading] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const username = location.state?.username;
  const otptype = location.state?.otptype;
  useEffect(() => {
    console.log(location.state);
    if (!username && !otptype) {
      navigate("/");
    }
  }, [username, otptype, navigate]);

  const handleOTPSubmit = (e) => {
    e.preventDefault();
    if (!loading) {
      setloading(true);
      setTimeout(() => {
        // Dummy OTP check
        if (otp === "123456") {
          setloading(false);
          handleAuthentication(true);
          navigate("/dashboard");
        } else {
          setloading(false);
          setOtp("");
          alert("Invalid OTP");
        }
      }, 1000);
    }
  };
  const handleBack = () => {
    navigate(-1);
  };
  return (
    <div className="login-wrap">
      <div className="login-innerwrap otp-innerwrap text-left">
        <button
          onClick={handleBack}
          className="btn border-0 w-auto p-0"
          type="button"
        >
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.1946 22.6946L6 12.5L16.1946 2.30542L18 4.11084L9.61058 12.5L18 20.8894L16.1946 22.6946Z"
              fill="#020202"
            />
          </svg>
        </button>
        <h1>OTP Verification</h1>

        <p className="mb-4">
          {otptype === "sms"
            ? "Check your phone messages for the code. Delivery time varies by service"
            : `Enter the code we have sent to ${username}`}
        </p>

        <div className="text-center mb-4">
          {otptype === "sms" && (
            <>
              <img src={otpicon} alt="otp icon" className="mb-2" />
              <div className="text text-primary">OTP sent via SMS</div>
              <div className="text text-secondary">+34 666 33 38 88</div>
            </>
          )}
        </div>
        <form onSubmit={handleOTPSubmit}>
          <div className="numeric-form mb-3">
            {/* <label className="form-label">OTP</label> */}
            {/* <input
            type="text"
            className="form-control"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            required
          /> */}

            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              renderSeparator={(index) =>
                index === 2 ? (
                  <span className="otpSeperatorDash">-</span>
                ) : (
                  <span className="otpSeperatorSpace"></span>
                )
              }
              renderInput={(props) => <input {...props} />}
            />
            {otptype !== "sms" && (
              <p className="otphelpertext">
                The delivery time may vary depending on your email service
                provider.
              </p>
            )}
          </div>
          <div className="timer text-center">
            <div className="label">We have sent you a code. Resend after:</div>
            <div className="timer-text">1:57</div>
          </div>
          <button type="submit" className="btn btn-primary">
            {loading && (
              <div class="spinner-border spinner-border-sm" role="status"></div>
            )}
            Continue
          </button>
        </form>
      </div>
    </div>
  );
};

export default EnterOTP;
